import { Record } from 'immutable';
import {
  CHANGE_PHONE_NUMBER_CONFIRM,
  CHANGE_PHONE_NUMBER_REJECT,
  CHANGE_PHONE_NUMBER_REQUEST
} from './actions';

const InitialState = new Record({
  newPhoneNumber: ''
});

export default (state = new InitialState(), action) => {
  switch (action.type) {
    case CHANGE_PHONE_NUMBER_REQUEST: {
      return state.set('newPhoneNumber', action.mobileNumber);
    }
    case CHANGE_PHONE_NUMBER_CONFIRM:
    case CHANGE_PHONE_NUMBER_REJECT: {
      return state.delete('newPhoneNumber');
    }
    default: {
      return state;
    }
  }
};
